/**
 * Resources catalog persistence client.
 *
 * Interim: browser localStorage overlay (see resourceCatalogStore).
 * When a durable content API ships, swap implementations behind these
 * functions without changing admin UI or public catalog merge.
 */

import type { ResourceItem } from './types';
import {
  readResourceOverlay,
  removeResourceOverlayItem,
  upsertResourceOverlayItem,
  writeResourceOverlay,
} from './resourceCatalogStore';

export const RESOURCE_CATALOG_PERSIST_MODE = 'localStorage_overlay_v1' as const;

export interface ResourceCatalogPersistContract {
  mode: typeof RESOURCE_CATALOG_PERSIST_MODE;
  storageKey: 'krysalis_resources_catalog_overlay_v1';
  scope: 'browser-local';
  durable: false;
  notes: string;
}

/** Documented interim persist contract until BE content API lands. */
export function getResourceCatalogPersistContract(): ResourceCatalogPersistContract {
  return {
    mode: RESOURCE_CATALOG_PERSIST_MODE,
    storageKey: 'krysalis_resources_catalog_overlay_v1',
    scope: 'browser-local',
    durable: false,
    notes:
      'Admin publish writes overlay rows; getMergedResourceCatalog merges overlay over seed. Not shared across browsers/devices.',
  };
}

export async function listPersistedResources(): Promise<ResourceItem[]> {
  return readResourceOverlay();
}

export async function savePersistedResource(item: ResourceItem): Promise<ResourceItem[]> {
  return upsertResourceOverlayItem(item);
}

export async function deletePersistedResource(id: string): Promise<ResourceItem[]> {
  return removeResourceOverlayItem(id);
}

export async function replacePersistedResources(items: ResourceItem[]): Promise<void> {
  writeResourceOverlay(items);
}
